import { useState } from 'react';
import PropTypes from 'prop-types';
import css from 'styled-jsx/css';

import paymentMethods from '../../../services/api/payment_methods';

const componentStyles = css`
  .error {
    font-size: 0.9rem;
    text-align: left;
  }

  .card-remove-button {
    margin: 0;
    padding: 0;
    font-size: 0.7rem;
    text-align: right;
    text-decoration: underline;
    background: none;
    border: none;
  }
`;

const RemovePaymentMethod = ({ card, remove }) => {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(false);
  const removeCard = async () => {
    if (submitting === true) {
      return false;
    }
    setSubmitting(true);
    const response = await paymentMethods.remove(card.id);
    if (response.ok) {
      setError(false);
      remove({ ...card, action: 'removed' });
    } else {
      setError(true);
      setSubmitting(false);
    }
  };
  // FIXME : extract higher order component to handle submitting and disabling.
  return (
    <>
      {error ? (
        <p className="error">
          Une erreur technique a empêché la supression de votre moyen de
          paiement. Veuillez essayer à nouveau. Si l’erreur persiste, contactez
          le support.
        </p>
      ) : null}
      <button
        disabled={submitting}
        className={'card-remove-button'}
        onClick={removeCard}
      >
        {submitting
          ? 'Suppression en cours...'
          : 'Supprimer ce moyen de paiement'}
      </button>
      <style jsx>{componentStyles}</style>
    </>
  );
};

RemovePaymentMethod.propTypes = {
  card: PropTypes.object.isRequired,
  remove: PropTypes.func.isRequired
};

export default RemovePaymentMethod;
